import cn from "classnames";
import { AddressField, Datetime, Field } from "components/shared/form";
import { validateForm } from "helpers/form";
import { paths } from "helpers/paths";
import { ymEvent } from "helpers/system";
import { requiredField } from "helpers/validators";
import pick from "lodash/pick";
import React, { useMemo, useState } from "react";

const config = {
    fromPointPlanEnterTime: {
        inputProps: { name: "fromPointPlanEnterTime" },
        label: "Плановая дата",
        inPortal: true,
        libOptions: { minDate: new Date() },
        required: true,
        validators: [requiredField],
    },
    contactPersonFullName: {
        inputProps: { name: "contactPersonFullName" },
        label: "ФИО контактного лица",
        required: true,
        validators: [requiredField],
    },
    contactPersonPhoneNumber: {
        inputProps: { name: "contactPersonPhoneNumber" },
        label: "Телефон контактного лица",
        type: "phone",
        required: true,
        validators: [requiredField],
    },
    toPoint: {
        inputProps: { name: "toPoint" },
        label: "Желаемое направление",
    },
};

export default function ForwardingOrder(props) {
    const [loading, setLoading] = useState(false);
    const [valid, setValid] = useState(true);

    const { back, saveData, profile } = props;
    const [data, setData] = useState(
        props.forwardingOrder ?? {
            toPoint: undefined,
            contactPersonFullName: profile.fullName,
            contactPersonPhoneNumber: profile.phoneNumber,
        },
    );

    const setValue = ({ name, value }) => setData({ ...data, [name]: value });

    const renderField = (name) => <Field {...config[name]} value={data[name]} onChange={setValue} />;

    const renderDateField = (name) => <Datetime {...config[name]} value={data[name]} onChange={setValue} />;

    const anyDirection = useMemo(() => {
        return (
            <div
                className="col-form-label-sm d-inline-block"
                onClick={() => setData({ ...data, toPoint: data.toPoint ? undefined : {} })}
            >
                <div className={cn("checkbox d-inline-block", { "checkbox--checked": !data.toPoint })} />
                &nbsp;
                <div className="d-inline-block checkbox__text">Любое направление</div>
            </div>
        );
    }, [data.toPoint]);

    const renderAddressField = (name) => (
        <AddressField
            {...config[name]}
            disabled={!data.toPoint}
            geopoint={data[name]}
            value={data[name]}
            onChange={setValue}
            inputBottomText={anyDirection}
            required={data.toPoint}
            validators={data.toPoint ? [requiredField] : []}
        />
    );

    const submitForm = (e) => {
        e.preventDefault();
        ymEvent("SaveReturnFlightRequest");
        setLoading(true);
        const orderData = pick(data, Object.keys(config));
        if (validateForm(config, orderData)) {
            setValid(true);
            saveData(orderData).then((res) => {
                if (res) {
                    props.back();
                }
                setLoading(false);
            });
        } else {
            setValid(false);
            setLoading(false);
        }
    };

    const removeOrder = () => {
        setLoading(true);
        saveData(null).then((res) => (res ? back() : setLoading(false)));
    };

    return (
        <form className={cn({ loading, "book-form__body--invalid": !valid })} onSubmit={submitForm}>
            {renderAddressField("toPoint")}
            {renderDateField("fromPointPlanEnterTime")}
            {renderField("contactPersonFullName")}
            {renderField("contactPersonPhoneNumber")}
            <div className="d-flex justify-content-between align-items-center">
                {props.forwardingOrder && (
                    <div>
                        <button className="btn btn-sm text-danger mr-2" type="button" onClick={removeOrder}>
                            Удалить заявку
                        </button>
                        <a
                            className="btn btn-sm btn-link"
                            onClick={() => ymEvent("ViewApplicationRequest")}
                            href={paths.forwardingTruckerPlanning}
                            target="_blank"
                            rel="noreferrer"
                        >
                            Просмотреть отправленный запрос
                        </a>
                    </div>
                )}
                <button className="btn btn-sm btn-brand" type="submit">
                    Сохранить
                </button>
            </div>
        </form>
    );
}
